import React from 'react';

interface SEOJsonLdProps {
  type: 'Organization' | 'WebPage' | 'FAQPage' | 'WebSite';
  overrides?: Record<string, any>;
  faqData?: Array<{ question: string; answer: string }>;
  pageTitle?: string;
  pageDescription?: string;
  pageUrl?: string;
}

export default function SEOJsonLd({ type, overrides = {}, faqData, pageTitle, pageDescription, pageUrl }: SEOJsonLdProps) {
  const siteUrl = (typeof window !== 'undefined' && (window as any).__VITE_SITE_URL__) || 'https://kangyong.com';

  const organizationLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Kang Yong Biotech',
    alternateName: '康永生技有限公司',
    url: siteUrl,
    description: 'Kang Yong Biotech is a HACCP/ISO 22000 certified health supplement OEM/ODM manufacturer in Taiwan, providing formula R&D, dosage form design, packaging, and quality certification services.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '6F, No. 79, Sec. 1, Zhongqing Rd., North Dist.',
      addressLocality: 'Taichung City',
      addressCountry: 'TW',
    },
    telephone: '+886-4-2202-9858',
    email: 'natural1070606@gmail.com',
    sameAs: ['https://lin.ee/X7Hcpf4'],
  };

  const websiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Kang Yong Biotech',
    url: siteUrl,
    description: 'Professional health supplement OEM/ODM manufacturing services in Taiwan. From formula R&D to packaging and delivery — your trusted manufacturing partner.',
    inLanguage: ['zh-TW', 'en', 'ja'],
  };

  const webPageLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: pageTitle || 'Kang Yong Biotech',
    description: pageDescription || 'Health supplement OEM/ODM manufacturer in Taiwan',
    url: pageUrl || siteUrl,
    isPartOf: { '@type': 'WebSite', name: 'Kang Yong Biotech', url: siteUrl },
    about: { '@type': 'Organization', name: 'Kang Yong Biotech' },
  };

  const faqPageLd = faqData ? {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  } : null;

  let json: Record<string, any>;
  switch (type) {
    case 'Organization':
      json = { ...organizationLd, ...overrides };
      break;
    case 'WebSite':
      json = { ...websiteLd, ...overrides };
      break;
    case 'FAQPage':
      json = faqPageLd || { ...webPageLd, '@type': 'FAQPage', ...overrides };
      break;
    case 'WebPage':
    default:
      json = { ...webPageLd, ...overrides };
      break;
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
    />
  );
}